<template>
  <div class="meta-item">
    <div class="wrapper">
      <font-awesome-icon v-if="icon" :icon="[this.icon.prefix, this.icon.iconName]" />
      <div class="description">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'LoanCardMetaItem',
    props: {
      icon: {
        type: Object,
        required: true,
      },
    },
    created () {
      this.$fa.add(this.icon)
    },
  }
</script>

<style lang="scss" scoped>
  @import "~assets/scss/frontend/_colours";

  .meta-item {
    .wrapper {
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: baseline;
      white-space: normal;
    }

    svg {
      color: $colour-green;
      font-size: 1.625rem; // 26px
      line-height: 1;
    }

    .description {
      font-size: 0.875rem; // 14px
      letter-spacing: -0.02rem;
      margin-top: 0.35rem;
      text-align: center;
    }
  }
</style>
